import React from 'react';
import './Class.css';

const CLASS_SCHEDULE = [
  { day: 'Monday', classes: ['Bhangra'], timings: ['Morning 7 to 8', 'Evening 5:30 to 6:30'] },
  { day: 'Tuesday', classes: ['Flooring'], timings: ['Morning 7 to 8', 'Evening 5:30 to 6:30'] },
  { day: 'Wednesday', classes: ['Thigh Workout'], timings: ['Morning 7 to 8', 'Evening 5:30 to 6:30'] },
  { day: 'Thursday', classes: ['Back Workout'], timings: ['Morning 7 to 8', 'Evening 5:30 to 6:30'] },
  { day: 'Friday', classes: ['Core Workout'], timings: ['Morning 7 to 8', 'Evening 5:30 to 6:30'] },
];

const Class = () => {
  return (
    <div className="class-container">
      <h1>Class Schedule</h1>
      <table className="class-table">
        <thead>
          <tr>
            <th>Day</th>
            <th>Classes</th>
            <th>Timings</th>
          </tr>
        </thead>
        <tbody>
          {CLASS_SCHEDULE.map((schedule, index) => (
            <tr key={index}>
              <td>{schedule.day}</td>
              <td>{schedule.classes.join(', ')}</td>
              <td>{schedule.timings.join(' / ')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Class;
